// src/presentation/pages/ClinicalExamination/sections/ApathySection.tsx
import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface ApathySectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const ApathySection: React.FC<ApathySectionProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <p className="text-sm text-gray-500">
          {t("clinicalSections.apathy.question")}
        </p>
      </div>
      <div>
        <RadioGroup
          value={value}
          onValueChange={onChange}
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="no-apathy" id="apathy-none" />
            <Label
              htmlFor="apathy-none"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.apathy.noApathy")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="slight-apathy" id="apathy-slight" />
            <Label
              htmlFor="apathy-slight"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.apathy.slightApathy")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="mild-apathy" id="apathy-mild" />
            <Label
              htmlFor="apathy-mild"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.apathy.mildApathy")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="moderate-apathy" id="apathy-moderate" />
            <Label
              htmlFor="apathy-moderate"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.apathy.moderateApathy")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="severe-apathy" id="apathy-severe" />
            <Label
              htmlFor="apathy-severe"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.apathy.severeApathy")}
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
